import { ShellRouteNames } from "../shell/route-names";

export const names = {
  all: `${ShellRouteNames.shell}.users-all`,
  single: `${ShellRouteNames.shell}.users-single`,
};
